// 娱乐爆料 · 精华盘点 —— 数据文件
// 所有人物均为内容创作所拟的虚构舞台名，事件描述仅为讨论性盘点，不对真人真事作定论。

export interface WeeklyItem {
  tag: string;
  title: string;
  summary: string;
  heat: number;
  word: string;
}

export interface AnnualCard {
  label: string;
  year: string;
  title: string;
  summary: string;
  point: string;
  img: string;
}

export interface MomentItem {
  tag: string;
  title: string;
  caption: string;
  img: string;
}

export interface FeatureItem {
  tag: string;
  title: string;
  excerpt: string;
  readMin: string;
  img: string;
}

export const site = {
  brand: '瓜友观察站',
  slogan: '娱乐爆料 · 精华盘点',
  email: 'hello@guanyou-daily.com',
  tagline: '大瓜合集，一网打尽',
  desc: '每周热门事件汇总、年度大瓜回顾、明星名场面合集，用最精炼的方式带你回顾娱乐圈的高光与争议时刻。',
};

export const ticker: string[] = [
  '古装剧《山海故人》大结局口碑两极化，编剧深夜发文回应',
  '顶流沈既明夜宵视频风波，工作室火速辟谣',
  '苏黎安红毯造型封神，热搜第一霸榜六小时',
  '《追光吧导演》现场翻车，导师席集体沉默',
  '七色堇成员陆遥宣布solo，团粉集体破防',
  '顾砚《长街灯》官宣，十年老搭档二搭引期待',
  '年度名场面混剪点击破亿，网友直呼笑不活了',
];

export const weeklyHot: WeeklyItem[] = [
  {
    tag: '剧集',
    title: '《山海故人》大结局争议，编剧长文复盘',
    summary: '收官当晚「烂尾」与「封神」两种声音刷屏，编剧连发三条长文回应争议，观众各执一词。',
    heat: 98,
    word: '热搜第一',
  },
  {
    tag: '人物',
    title: '沈既明夜宵视频风波，工作室深夜辟谣',
    summary: '模糊画质引发的连续剧，从被拍到被猜、再到工作室盖章「只是朋友聚餐」，全程仅六小时。',
    heat: 95,
    word: '霸榜',
  },
  {
    tag: '红毯',
    title: '苏黎安红毯造型封神，配饰比礼服更出圈',
    summary: '高定裙摆配东方鎏金头饰，话题阅读量单日破五亿，造型团队凌晨发文致谢。',
    heat: 91,
    word: '出圈',
  },
  {
    tag: '综艺',
    title: '《追光吧导演》现场翻车，导师集体沉默',
    summary: '青年导演临时改本导致录制中断，现场一片安静的名场面成为本周讨论焦点。',
    heat: 86,
    word: '名场面',
  },
  {
    tag: '组合',
    title: '七色堇陆遥官宣solo，团粉集体破防',
    summary: '官宣文案用了「暂别」而非「退团」，字里行间给足想象空间，粉丝连夜整理时间线。',
    heat: 82,
    word: '热议',
  },
  {
    tag: '官宣',
    title: '顾砚《长街灯》二搭，十年老搭档再续前缘',
    summary: '从对手戏到并肩戏，两人合作十年的情谊被反复考古，官宣即热度峰值。',
    heat: 78,
    word: '期待',
  },
];

export const annualCards: AnnualCard[] = [
  {
    label: '年度盘',
    year: '2026',
    title: '上半年：一场发布会掀起的「考古」热浪',
    summary: '从一句话梗到十年前的花絮，网友把旧物料盘出包浆，也让沉寂多年的冷门剧意外翻红。',
    point: '38 条事件 · 12 场热搜',
    img: 'https://readdy.ai/api/search-image?query=warm%20editorial%20studio%20collage%20of%20golden%20vintage%20film%20stills%20polaroid%20photos%20scattered%20on%20cream%20desk%20with%20coffee%20cup%20retro%20film%20camera%20soft%20cinematic%20warm%20amber%20lighting%20magazine%20archive%20aesthetic%20nostalgic%20atmosphere%20high%20detail%20no%20people%20no%20text&width=800&height=500&seq=annual-2026-1&orientation=landscape',
  },
  {
    label: '颁奖季',
    year: '2025',
    title: '一场红毯把内娱审美顶上风口浪尖',
    summary: '领奖台与红毯上的高光与翻车交替上演，造型盘点被做成二创，成为全年最出圈的物料来源。',
    point: '28 条事件 · 3 档奖项',
    img: 'https://readdy.ai/api/search-image?query=elegant%20awards%20ceremony%20red%20carpet%20scene%20with%20warm%20golden%20bokeh%20stage%20lights%20and%20blurred%20crowd%20silhouettes%20glowing%20crimson%20velvet%20backdrop%20cinematic%20warm%20editorial%20photography%20glamorous%20magazine%20aesthetic%20soft%20lens%20flare%20no%20text%20no%20clear%20faces&width=800&height=500&seq=annual-2025-1&orientation=landscape',
  },
  {
    label: '暑期档',
    year: '2024',
    title: '爆款剧带火古偶，口碑与数据一起狂飙',
    summary: '多部古装剧同台竞技，从服化道到剧本改编都被逐帧分析，追剧文化演变成一场集体狂欢。',
    point: '24 条事件 · 10 部剧',
    img: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20drama%20set%20with%20flowing%20silk%20robes%20hanging%20warm%20lanterns%20glowing%20golden%20and%20ink%20washed%20mountains%20backdrop%20cinematic%20warm%20amber%20editorial%20photography%20romantic%20atmosphere%20high%20detail%20no%20people%20no%20text&width=800&height=500&seq=annual-2024-1&orientation=landscape',
  },
  {
    label: '年末档',
    year: '2023',
    title: '跨年晚会名场面合集，网友二创封神',
    summary: '从嘉宾合唱到舞台意外，跨年舞台贡献了全年最大批次的「名场面」，切片播放量集体破千万。',
    point: '30 条事件 · 6 台晚会',
    img: 'https://readdy.ai/api/search-image?query=year%20end%20countdown%20concert%20stage%20with%20golden%20confetti%20falling%20and%20sparkling%20warm%20stadium%20lights%20glowing%20screen%20reflections%20energetic%20festive%20cinematic%20warm%20editorial%20photography%20glowing%20orange%20and%20amber%20tone%20no%20clear%20faces%20no%20text&width=800&height=500&seq=annual-2023-1&orientation=landscape',
  },
];

export const momentItems: MomentItem[] = [
  {
    tag: '采访',
    title: '主持人连环追问，演员当场愣住',
    caption: '三秒沉默被做成表情包，网友：这停顿值一座影帝奖杯。',
    img: 'https://readdy.ai/api/search-image?query=cinematic%20talk%20show%20interview%20stage%20with%20warm%20orange%20spotlight%20and%20elegant%20guest%20silhouette%20sitting%20in%20a%20plush%20sofa%20glowing%20amber%20studio%20lights%20soft%20bokeh%20background%20editorial%20magazine%20photography%20warm%20cinematic%20grade%20dramatic%20atmosphere%20no%20text&width=640&height=800&seq=moment-1&orientation=portrait',
  },
  {
    tag: '综艺',
    title: '导演临时改本，导师集体沉默',
    caption: '全场安静的那十秒，被网友称为综艺之神时刻。',
    img: 'https://readdy.ai/api/search-image?query=moody%20film%20studio%20director%20chair%20scene%20with%20warm%20harsh%20stage%20lamp%20glow%20film%20clapperboard%20and%20blurred%20silhouettes%20of%20judges%20sitting%20in%20a%20row%20dramatic%20red%20and%20amber%20color%20grade%20cinematic%20editorial%20photography%20tense%20atmosphere%20no%20clear%20faces%20no%20text&width=640&height=800&seq=moment-2&orientation=portrait',
  },
  {
    tag: '红毯',
    title: '苏黎安鎏金头饰封神造型',
    caption: '东方鎏金配高定裙摆，被造型团队连夜做成置顶海报。',
    img: 'https://readdy.ai/api/search-image?query=glamorous%20elegant%20woman%20in%20flowing%20warm%20toned%20evening%20gown%20with%20golden%20ornate%20hairpiece%20standing%20on%20red%20carpet%20warm%20golden%20bokeh%20studio%20lights%20cinematic%20editorial%20magazine%20fashion%20photography%20rich%20amber%20and%20crimson%20palette%20graceful%20pose%20soft%20glow%20no%20text&width=640&height=800&seq=moment-3&orientation=portrait',
  },
  {
    tag: '团综',
    title: '陆遥即兴清唱，队友集体愣住',
    caption: '一段无伴奏清唱被考古，评论区刷起原来她一直很能唱。',
    img: 'https://readdy.ai/api/search-image?query=young%20singer%20silhouette%20singing%20into%20a%20warm%20glowing%20stage%20microphone%20with%20amber%20backlight%20and%20soft%20stage%20smoke%20cinematic%20warm%20editorial%20photography%20concert%20vibe%20golden%20and%20orange%20tone%20atmospheric%20glow%20no%20clear%20face%20no%20text&width=640&height=800&seq=moment-4&orientation=portrait',
  },
  {
    tag: '发布会',
    title: '官宣二搭，现场重播十年前同框',
    caption: '大屏幕切出十年前的对手戏，现场响起全场欢呼。',
    img: 'https://readdy.ai/api/search-image?query=press%20conference%20stage%20with%20large%20glowing%20warm%20screen%20showing%20blurred%20vintage%20film%20still%20silhouettes%20of%20two%20actors%20on%20stage%20with%20warm%20amber%20stage%20lighting%20and%20confetti%20cinematic%20editorial%20photography%20nostalgic%20golden%20tone%20celebration%20atmosphere%20no%20text&width=640&height=800&seq=moment-5&orientation=portrait',
  },
  {
    tag: '现场',
    title: '歌手忘词，即兴接梗反而封神',
    caption: '忘词瞬间被现场观众起哄，一句即兴接梗把全场唱笑。',
    img: 'https://readdy.ai/api/search-image?query=live%20concert%20crowd%20with%20raised%20hands%20and%20warm%20golden%20stage%20lights%20glowing%20beams%20singer%20silhouette%20on%20stage%20energetic%20festive%20atmosphere%20cinematic%20warm%20amber%20editorial%20photography%20music%20festival%20vibe%20bokeh%20lights%20no%20clear%20faces%20no%20text&width=640&height=800&seq=moment-6&orientation=portrait',
  },
];

export const featureItems: FeatureItem[] = [
  {
    tag: '深度',
    title: '一场发布会，如何让三年前的冷门剧集体翻红',
    excerpt: '当「考古」成为追剧新姿势，旧物料不再只是怀旧，而是被重新解读成流量密码。本文拆解一场发布会引发的连锁反应。',
    readMin: '8 分钟',
    img: 'https://readdy.ai/api/search-image?query=stack%20of%20retro%20vintage%20film%20discs%20and%20old%20magazine%20clippings%20arranged%20on%20a%20warm%20cream%20desk%20with%20soft%20golden%20window%20light%20research%20archive%20mood%20editorial%20photography%20cinematic%20warm%20amber%20grade%20nostalgic%20and%20thoughtful%20atmosphere%20high%20detail%20no%20people%20no%20text&width=900&height=560&seq=feature-1&orientation=landscape',
  },
  {
    tag: '观察',
    title: '红毯审美三十年：我们到底在看什么',
    excerpt: '从造型盘点聊到内娱审美变迁，红毯早已不只是红毯，而是大众情绪的一面镜子。',
    readMin: '6 分钟',
    img: 'https://readdy.ai/api/search-image?query=red%20carpet%20photographer%20scene%20with%20warm%20flashing%20camera%20lights%20and%20golden%20bokeh%20backdrop%20elegant%20fashion%20mannequins%20silhouettes%20in%20flowing%20dresses%20blurred%20cinematic%20warm%20amber%20editorial%20photography%20glamorous%20reflective%20atmosphere%20no%20text&width=900&height=560&seq=feature-2&orientation=landscape',
  },
  {
    tag: '盘点',
    title: '从团粉破防到全员上桌，粉丝文化十年变脸',
    excerpt: '十年间，追星从私域走向公共议题。我们整理了粉丝群体话语变迁的几个关键节点。',
    readMin: '9 分钟',
    img: 'https://readdy.ai/api/search-image?query=modern%20fans%20holding%20glowing%20warm%20lightsticks%20in%20a%20concert%20crowd%20blurred%20golden%20and%20orange%20bokeh%20lights%20energetic%20community%20atmosphere%20cinematic%20warm%20editorial%20photography%20sense%20of%20togetherness%20no%20clear%20faces%20no%20text&width=900&height=560&seq=feature-3&orientation=landscape',
  },
];

export const faqs = [
  {
    q: '精华盘点多久更新一次？',
    a: '本站以周更为主：每周一更新上周娱乐圈热门事件汇总榜单，月末追加月度名场面合集，年底推出一整年的大瓜回顾专题。',
  },
  {
    q: '榜单里的「热度」是怎么来的？',
    a: '热度综合了讨论声量、传播时长与话题发酵范围三个维度，仅用于反映话题在内容社区的活跃程度，不代表任何立场判断。',
  },
  {
    q: '内容里的信息是否经过核实？',
    a: '本站定位为「观点化盘点」，会对已公开信息进行整理与交叉比对；涉及未经证实的说法会明确标注为「网传」「待证实」，不对艺人个人品质作定论。',
  },
  {
    q: '我看到了错误的信息，如何反馈？',
    a: '欢迎通过站内订阅表单或邮箱 hello@guanyou-daily.com 联系我们。核实无误后，我们会在当周盘点中标注更正。',
  },
  {
    q: '可以转载或引用这里的盘点吗？',
    a: '欢迎在注明来源（瓜友观察站）的前提下，以非商业目的转载内容摘要；全文转载与商业使用请先与我们取得联系并获得授权。',
  },
];